module.exports = __webpack_public_path__ + "static/shoes-2c0c8ba637918d23092ed175b49088fe.png";